import {
  ProfessionalsSection,
  HolisticSearch,
  ReserveNow,
  StepsProcessSection,
  ActionIntroSection,
  NewsSection,
  NewsletterSubscription,
  ManifestoSection,
  TeamSection,
  MediaShowcase
} from "../../components/Landing";
import { MainHeroSection } from "../../components/Landing/MainHeroSection/MainHeroSection";
import { MainEvolutionarySection } from "../../components/Landing/MainEvolutionarySection/MainEvolutionarySection";
import { useHome } from './hooks/useHome';

const Home = () => {
  const { container } = useHome();

  return (
    <div className="home" ref={container}>
      <MainHeroSection />
      <MainEvolutionarySection />
      <MediaShowcase />
      <ManifestoSection />
      <HolisticSearch />
      <StepsProcessSection />
      <div id="profesionales-carousel">
        <ProfessionalsSection />
      </div>
      <ReserveNow />
      <TeamSection />
      <NewsSection />
      <ActionIntroSection />
      <NewsletterSubscription />
    </div>
  );
};

export default Home;
